<template>
    <f7-page
        :page-content="false"
        name="Onboarding 2"
        navbar-hidden
        no-navbar
        class="onboardingBg"
    >
        <div class="bg-wrapper">
            <div class="parallax-bg" />
            <div class="parallax-bg-2" />
            <div style="max-width: 400px; margin: 120px auto 0">
                <f7-block style="text-align: left">
                    <span class="sectionTitle">I am a</span>

                    <f7-segmented
                        :class="`segOnb2 ${genderActived ? 'activated' : ''}`"
                        strong
                        tag="p"
                    >

                        <f7-button
                            v-for="(gender, index) in genders"
                            :active="gender.active"
                            :key="`trait1-${index}`"
                            @click="genderActived = true; gender2Actived = false; changeGender(index);changeTrait(gender.traitId);changeAny();"
                        >{{ gender.name }}</f7-button>
                    </f7-segmented>
                    <f7-segmented
                        v-if="showGenders2"
                        :class="`segOnb2 ${gender2Actived ? 'activated' : ''}`"
                        strong
                        tag="p"
                    >
                        <f7-button
                            v-for="(gender, index) in genders2"
                            :active="gender.active"
                            :key="`trait1a-${index}`"
                            @click="gender2Actived = true; genderActived = false; changeGender(index, true);changeTrait(gender.traitId);changeAny();"
                        >{{ gender.name }}</f7-button>
                    </f7-segmented>
                    <span class="sectionTitle">in my ...ies</span>
                    <f7-segmented
                        :class="`segOnb2 ${ageActived ? 'activated' : ''}`"
                        strong
                        tag="p"
                    >
                        <f7-button
                            v-for="(age, index) in ages"
                            :active="age.active"
                            :key="`trait2-${index}`"
                            @click="ageActived = true; age2Actived = false; age3Actived = false; changeAge(index);changeTrait(age.traitId);changeAny();"
                        >{{ age.name }}</f7-button>
                    </f7-segmented>
                    <f7-segmented
                        v-if="showAge2"
                        :class="`segOnb2 ${age2Actived ? 'activated' : ''}`"
                        strong
                        tag="p"
                    >
                        <f7-button
                            v-for="(gender, index) in ages2"
                            :active="gender.active"
                            :key="`age2-${index}`"
                            @click="age2Actived = true; changeAge(index, 1);changeTrait(gender.traitId);changeAny();"
                        >{{ gender.name }}</f7-button>
                    </f7-segmented>
                    <f7-segmented
                        v-if="showAge3"
                        :class="`segOnb2 ${age3Actived ? 'activated' : ''}`"
                        strong
                        tag="p"
                    >
                        <f7-button
                            v-for="(gender, index) in ages3"
                            :active="gender.active"
                            :key="`age3-${index}`"
                            @click="age3Actived = true; changeAge(index, 2);changeTrait(gender.traitId);changeAny();"
                        >{{ gender.name }}</f7-button>
                    </f7-segmented>
                    <span class="sectionTitle">interested in</span>
                    <f7-segmented
                        :class="`segOnb2 ${int2Actived ? 'activated' : ''}`"
                        strong
                        tag="p"
                    >
                        <f7-button
                            v-for="(orientation, index) in orientations"
                            :active="orientation.active"
                            :key="`trait3-${index}`"
                            @click="int2Actived = true; changeOrientation(index);changeTrait(orientation.traitId);changeAny();"
                        >{{ orientation.name }}</f7-button>
                    </f7-segmented>
                    <span class="sectionTitle">my relationship status is</span>
                    <f7-segmented
                        :class="`segOnb2 ${relaActived ? 'activated' : ''}`"
                        strong
                        tag="p"
                    >
                        <f7-button
                            v-for="(relationship, index) in relationships"
                            :active="relationship.active"
                            :key="`trait3-${index}`"
                            rounded
                            @click="relaActived = true; changeRelationship(index);changeTrait(relationship.traitId);changeAny();"
                        >{{ relationship.name }}</f7-button>
                    </f7-segmented>
                    <!-- <span class="sectionTitle">and I am here for</span> -->
                    <!-- <f7-segmented
                strong
                tag="p"
            >
                <f7-button
                    v-for="(reason, index) in reasons"
                    :active="reason.active"
                    rounded
                    :key="`trait4-${index}`"
                    @click="changeReasons(index);changeTrait(reason.traitId); changeAny();"
                >{{reason.name}}</f7-button>
            </f7-segmented> -->
                    <!-- -->
                </f7-block>
            </div>
            <f7-block class="absBottom">
                <f7-button
                    :color="answers.length === 4 ? 'red' : 'grayer'"
                    href="#"
                    fill
                    round
                    @click="goToNextPage"
                >{{ answers.length === 4 ? 'Continue' : 'Answer questions to continue' }}</f7-button>
            </f7-block>
        </div>
    </f7-page>
</template>

<script>
export default {
    store: ['api', 'text', 'user', 'traits', 'traitsIndex', 'myTraits', 'myValueTraits'],
    data () {
        return {
            ageActived: false,
            genderActived: false,
            int2Actived: false,
            answers: [],
            answersId: [],
            traitsByGroup: [],
            genders: [{
                name: 'Man',
                active: false,
                traitId: 1,
            }, {
                name: 'Woman',
                active: false,
                traitId: 2,
            }, {
                name: 'More',
                active: false,
                traitId: 3,
            }],
            showGenders2: false,
            genders2: [
                {
                    name: 'Trans-Masculine',
                    active: false,
                    traitId: 42,
                },
                {
                    name: 'Trans-Feminine',
                    active: false,
                    traitId: 51,
                },
                {
                    name: 'Genderqueer',
                    active: false,
                    traitId: 3,
                }
            ],
            ages: [
                {
                    name: '<20',
                    active: false,
                    traitId: 45,
                },
                {
                    name: '20',
                    active: false,
                    traitId: 46,
                },
                {
                    name: '30',
                    active: false,
                    traitId: 48,
                },
                {
                    name: '40',
                    active: false,
                    traitId: 50,
                },
                {
                    name: '50',
                    active: false,
                    traitId: 58,
                },
                {
                    name: '60',
                    active: false,
                    traitId: 60,
                },
                {
                    name: '70+',
                    active: false,
                    traitId: 61,
                }
            ],
            showAge2: false,
            ages2: [
                {
                    name: '20-24',
                    active: false,
                    traitId: 46,
                },
                {
                    name: '25-29',
                    active: false,
                    traitId: 47,
                },
            ],
            showAge3: false,
            ages3: [
                {
                    name: '30-34',
                    active: false,
                    traitId: 48,
                },
                {
                    name: '35-39',
                    active: false,
                    traitId: 49,
                },
            ],
            orientations: [
                {
                    name: 'Men',
                    active: false,
                    traitId: 25,
                },
                {
                    name: 'Women',
                    active: false,
                    traitId: 24,
                },
                {
                    name: 'Everyone',
                    active: false,
                    traitId: 23,
                }
            ],
            relationships: [
                {
                    name: 'In one',
                    active: false,
                    traitId: 13,
                },
                {
                    name: 'Not in one',
                    active: false,
                    traitId: 14,
                },
                {
                    name: 'Mmm...',
                    active: false,
                    traitId: 74,
                }
            ],
            relaActived: false,
            reasons: [
                {
                    name: 'Fun',
                    active: false,
                    traitId: 71,
                },
                {
                    name: 'Issues',
                    active: false,
                    traitId: 72,
                },
                {
                    name: 'Both',
                    active: false,
                    traitId: 73,
                }
            ],
            bullets: [
                {
                    desc: `man','20-40','interested in men','in a relationship`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 25, 13],
                    text: ['When one partner wants it more', 'Drive him wild', 'Giving men pleasure with hands']
                },
                {
                    desc: `man','20-40','interested in men','single-complicated`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 25, 14, 74],
                    text: ['What’s your desire type?', 'Drive him wild', 'Giving men pleasure with hands']
                },
                {
                    desc: `man','20-40','interested in women','in a relationship`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 24, 13],
                    text: ['When one partner wants it more', 'Master dirty talk', 'Make her come for real']
                },
                {
                    desc: `man','20-40','interested in women','single-complicated`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 24, 14, 74],
                    text: ['Make her toes curl', 'Want more pleasure?', 'Shift your self pleasure script']
                },
                {
                    desc: `man','20-40','interested in everyone','in a relationship`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 23, 13],
                    text: ['When one partner wants it more', 'Communication is key', 'Master dirty talk']
                },
                {
                    desc: `man','20-40','interested in everyone','single-complicated`,
                    traits: [1, 45, 46, 47, 48, 49, 50, 23, 14, 74],
                    text: ['What’s your desire type?', 'Want more pleasure?', 'Shift your self pleasure script']
                },
                {
                    desc: `man','50-70','interested in men','in a relationship`,
                    traits: [1, 58, 60, 61, 25, 13],
                    text: ['When one partner wants it more', 'Drive him wild', 'Improve erection performance']
                },
                {
                    desc: `man','50-70','interested in men','single-complicated`,
                    traits: [1, 58, 60, 61, 25, 14, 74],
                    text: ['Drive him wild', 'Giving men pleasure with hands', 'Improve erection performance']
                },
                {
                    desc: `man','50-70','interested in women','in a relationship`,
                    traits: [1, 58, 60, 61, 24, 13],
                    text: ['When one partner wants it more', 'Make her toes curl', 'Improve erection performance']
                },
                {
                    desc: `man','50-70','interested in women','single-complicated`,
                    traits: [1, 58, 60, 61, 24, 14, 74],
                    text: ['Make her toes curl', 'Shift your self pleasure script', 'Improve erection performance']
                },
                {
                    desc: `man','50-70','interested in everyone','in a relationship`,
                    traits: [1, 58, 60, 61, 23, 13],
                    text: ['When one partner wants it more', 'Communication is key', 'Improve erection performance']
                },
                {
                    desc: `man','50-70','interested in everyone','single-complicated`,
                    traits: [1, 58, 60, 61, 23, 14, 74],
                    text: ['Want more pleasure?', 'Shift your self pleasure script', 'Improve erection performance']
                },
                {
                    desc: `woman','20-40','interested in men','in a relationship`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 25, 13],
                    text: ['What’s your desire type?', 'When one partner wants it more', 'Drive him wild']
                },
                {
                    desc: `woman','20-40','interested in men','single-complicated`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 25, 14, 74],
                    text: ['What’s your desire type?', 'Shift your self pleasure script', 'Drive him wild']
                },
                {
                    desc: `woman','20-40','interested in women','in a relationship`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 24, 13],
                    text: ['What’s your desire type?', 'Make her toes curl', 'When one partner wants it more']
                },
                {
                    desc: `woman','20-40','interested in women','single-complicated`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 24, 14, 74],
                    text: ['What’s your desire type?', 'Make her toes curl', 'Shift your self pleasure script']
                },
                {
                    desc: `woman','20-40','interested in everyone','in a relationship`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 23, 13],
                    text: ['What’s your desire type?', 'When one partner wants it more', 'Master dirty talk']
                },
                {
                    desc: `woman','20-40','interested in everyone','single-complicated`,
                    traits: [2, 45, 46, 47, 48, 49, 50, 23, 14, 74],
                    text: ['What’s your desire type?', 'Want more pleasure?', 'Shift your self pleasure script']
                },
                {
                    desc: `woman','50-70','interested in men','in a relationship`,
                    traits: [2, 58, 60, 61, 25, 13],
                    text: ['When one partner wants it more', 'Body and mind out of sync?', 'Want more pleasure? ']
                },
                {
                    desc: `woman','50-70','interested in men','single-complicated`,
                    traits: [2, 58, 60, 61, 25, 14, 74],
                    text: ['Drive him wild', 'Want more pleasure?', 'Body and mind out of sync?']
                },
                {
                    desc: `woman','50-70','interested in women','in a relationship`,
                    traits: [2, 58, 60, 61, 24, 13],
                    text: ['When one partner wants it more', 'Make her toes curl', 'Body and mind out of sync?']
                },
                {
                    desc: `woman','50-70','interested in women','single-complicated`,
                    traits: [2, 58, 60, 61, 24, 14, 74],
                    text: ['Make her toes curl', 'Want more pleasure?', 'Body and mind out of sync?']
                },
                {
                    desc: `woman','50-70','interested in everyone','in a relationship`,
                    traits: [2, 58, 60, 61, 23, 13],
                    text: ['When one partner wants it more', 'Want more pleasure?', 'Body and mind out of sync?']
                },
                {
                    desc: `woman','50-70','interested in everyone','single-complicated`,
                    traits: [2, 58, 60, 61, 23, 14, 74],
                    text: ['Want more pleasure?', 'Body and mind out of sync?', 'Shift your self pleasure script']
                },
                {
                    desc: `other','20-40','interested in men','in a relationship`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Drive him wild']
                },
                {
                    desc: `other','20-40','interested in men','single-complicated`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 25, 14, 74],
                    text: ['Drive him wild', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `other','20-40','interested in women','in a relationship`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 24, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Make her toes curl']
                },
                {
                    desc: `other','20-40','interested in women','single-complicated`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 24, 14, 74],
                    text: ['Make her toes curl', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `other','20-40','interested in everyone','in a relationship`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 23, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Master dirty talk']
                },
                {
                    desc: `other','20-40','interested in everyone','single-complicated`,
                    traits: [3, 45, 46, 47, 48, 49, 50, 23, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Master dirty talk']
                },
                {
                    desc: `other','50-70','interested in men','in a relationship`,
                    traits: [3, 58, 60, 61, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Drive him wild']
                },
                {
                    desc: `other','50-70','interested in men','single-complicated`,
                    traits: [3, 58, 60, 61, 25, 14, 74],
                    text: ['Drive him wild', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `other','50-70','interested in women','in a relationship`,
                    traits: [3, 58, 60, 61, 24, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Make her toes curl']
                },
                {
                    desc: `other','50-70','interested in women','single-complicated`,
                    traits: [3, 58, 60, 61, 24, 14, 74],
                    text: ['Make her toes curl', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `other','50-70','interested in everyone','in a relationship`,
                    traits: [3, 58, 60, 61, 23, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `other','50-70','interested in everyone','single-complicated`,
                    traits: [3, 58, 60, 61, 23, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Shift your self pleasure script']
                },
                {
                    desc: `trans-masculine','20-40','interested in men','in a relationship`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Drive him wild']
                },
                {
                    desc: `trans-masculine','20-40','interested in men','single-complicated`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 25, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Drive him wild']
                },
                {
                    desc: `trans-masculine','20-40','interested in women','in a relationship`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 24, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Make her toes curl']
                },
                {
                    desc: `trans-masculine','20-40','interested in women','single-complicated`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 24, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Make her toes curl']
                },
                {
                    desc: `trans-masculine','20-40','interested in everyone','in a relationship`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 23, 13],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'When one partner wants it more']
                },
                {
                    desc: `trans-masculine','20-40','interested in everyone','single-complicated`,
                    traits: [42, 45, 46, 47, 48, 49, 50, 23, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Want more pleasure?']
                },
                {
                    desc: `trans-masculine','50-70','interested in men','in a relationship`,
                    traits: [42, 58, 60, 61, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-masculine','50-70','interested in men','single-complicated`,
                    traits: [42, 58, 60, 61, 25, 14, 74],
                    text: ['Drive him wild', 'Exploring trans & genderqueer sexuality', 'Journey over destination'],
                }, {
                    desc: `trans-masculine','50-70','interested in women','in a relationship`,
                    traits: [42, 58, 60, 61, 24, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-masculine','50-70','interested in women','single-complicated`,
                    traits: [42, 58, 60, 61, 24, 14, 74],
                    text: ['Make her toes curl', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-masculine','50-70','interested in everyone','in a relationship`,
                    traits: [42, 58, 60, 61, 23, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-masculine','50-70','interested in everyone','single-complicated`,
                    traits: [42, 58, 60, 61, 23, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','20-40','interested in men','in a relationship`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'What’s your desire type?']
                },
                {
                    desc: `trans-feminine','20-40','interested in men','single-complicated`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 25, 14, 74],
                    text: ['Drive him wild', 'Exploring trans & genderqueer sexuality', 'What’s your desire type?']
                },
                {
                    desc: `trans-feminine','20-40','interested in women','in a relationship`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 24, 13],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'When one partner wants it more']
                },
                {
                    desc: `trans-feminine','20-40','interested in women','single-complicated`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 24, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Make her toes curl']
                },
                {
                    desc: `trans-feminine','20-40','interested in everyone','in a relationship`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 23, 13],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'When one partner wants it more']
                },
                {
                    desc: `trans-feminine','20-40','interested in everyone','single-complicated`,
                    traits: [43, 45, 46, 47, 48, 49, 50, 23, 14, 74],
                    text: ['What’s your desire type?', 'Exploring trans & genderqueer sexuality', 'Want more pleasure?']
                },
                {
                    desc: `trans-feminine','50-70','interested in men','in a relationship`,
                    traits: [43, 58, 60, 61, 25, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','50-70','interested in men','single-complicated`,
                    traits: [43, 58, 60, 61, 25, 14, 74],
                    text: ['Drive him wild', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','50-70','interested in women','in a relationship`,
                    traits: [43, 58, 60, 61, 24, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','50-70','interested in women','single-complicated`,
                    traits: [43, 58, 60, 61, 24, 14, 74],
                    text: ['Make her toes curl', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','50-70','interested in everyone','in a relationship`,
                    traits: [43, 58, 60, 61, 23, 13],
                    text: ['When one partner wants it more', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
                {
                    desc: `trans-feminine','50-70','interested in everyone','single-complicated`,
                    traits: [43, 58, 60, 61, 23, 14, 74],
                    text: ['Want more pleasure?', 'Exploring trans & genderqueer sexuality', 'Journey over destination']
                },
            ],
        };
    },
    computed: {
        device: function () {
            return f7.device;
        }
    },
    mounted: function () {

    },
    methods: {
        changeAny: function () {
            let selectedBullet = 0;
            let correctMax = 0;
            for (let i = 0; i < this.bullets.length; i++) {
                const bullet = this.bullets[i];
                let localMax = 0;
                for (let j = 0; j < 6; j++) {
                    const ans = this.answersId[j];
                    if (bullet.traits.indexOf(ans) > -1) localMax++;
                }
                if (localMax > correctMax) {
                    correctMax = localMax;
                    // console.log(localMax, correctMax, i)
                    selectedBullet = i;
                }
            }
            window.localStore.setItem('selectedBullet', selectedBullet);
        },
        changeGender: function (index, two) {
            for (let i = 0; i < this.genders.length; i++) {
                const element = this.genders[i];
                element.active = false;
            }
            for (let i = 0; i < this.genders2.length; i++) {
                const element = this.genders2[i];
                element.active = false;
            }
            if (two) {
                this.genders2[index].active = true;
                this.answersId[0] = this.genders2[index].traitId;
            } else {
                this.genders[index].active = true;
                this.answersId[0] = this.genders[index].traitId;
            }
            if (this.answers.indexOf('gender') === -1) this.answers.push('gender');
            if (!two && index === 2) {
                this.showGenders2 = true;
            } else if (!two) {
                this.showGenders2 = false;
            }
        },
        changeAge: function (index, level) {
            if (this.answers.indexOf('age') === -1) this.answers.push('age');
            if (level === 1) {
                for (let i = 0; i < this.ages2.length; i++) {
                    const element = this.ages2[i];
                    element.active = false;
                }
                this.ages2[index].active = true;
                this.answersId[1] = this.ages2[index].traitId;
            } else if (level === 2) {
                for (let i = 0; i < this.ages3.length; i++) {
                    const element = this.ages3[i];
                    element.active = false;
                }
                this.ages3[index].active = true;
                this.answersId[1] = this.ages3[index].traitId;
            } else {
                for (let i = 0; i < this.ages.length; i++) {
                    const element = this.ages[i];
                    element.active = false;
                }
                this.ages[index].active = true;
                this.answersId[1] = this.ages[index].traitId;
            }
            if (!level) {
                this.showAge2 = false;
                this.showAge3 = false;
                if (index === 1) this.showAge2 = true;
                if (index === 2) this.showAge3 = true;
            }
        },
        changeOrientation: function (index) {
            for (let i = 0; i < this.orientations.length; i++) {
                const element = this.orientations[i];
                element.active = false;
            }
            if (this.answers.indexOf('orientation') === -1) this.answers.push('orientation');
            this.orientations[index].active = true;
            this.answersId[2] = this.orientations[index].traitId;
        },
        changeRelationship: function (index) {
            for (let i = 0; i < this.relationships.length; i++) {
                const element = this.relationships[i];
                element.active = false;
            }
            if (this.answers.indexOf('relationship') === -1) this.answers.push('relationship');
            this.relationships[index].active = true;
            this.answersId[3] = this.relationships[index].traitId;
        },
        changeReasons: function (index) {
            for (let i = 0; i < this.reasons.length; i++) {
                const element = this.reasons[i];
                element.active = false;
            }
            if (this.answers.indexOf('reason') === -1) this.answers.push('reason');
            this.reasons[index].active = true;
            this.answersId[4] = this.reasons[index].traitId;
        },
        changeTrait: function (traitId) {
            if (!traitId) return;
            this.$http
                .post(`${this.api}/users/${this.user.id}/traits`, {
                    traitId,
                })
                .then(
                    response => {
                        this.myTraits = response.body.traits || [];
                        this.myValueTraits = response.body.valueTraits || [];
                        if (this.myTraits.length > 3) this.$events.fire('userUpdateTraits');
                        f7.preloader.hide();
                    },
                    response => {
                        f7.preloader.hide();
                        f7.dialog.alert(response.body.message || 'Unknown error');
                    }
                );
        },
        goToNextPage: function () {
            if (this.answers.length < 4) return;
            f7.views['main'].router.navigate('/onboarding3');
        },

    }
};
</script>
<style lang="less">
.segOnb2 {
    .segmented-highlight {
        opacity: 0;
    }
    .button {
        padding: 0px 4px;
    }
    &.activated {
        .segmented-highlight {
            opacity: 1;
        }
    }
}
</style>
<style lang="less" scoped>
.center {
    text-align: center;
}
.segOnb2 {
    margin-bottom: 22px;
    margin-top: 6px;
}
.bg-wrapper {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
}
.parallax-bg {
    position: absolute;
    left: calc(~'-800px' - 50vw);
    top: 0;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_top.png) top right no-repeat;
    background-size: 3670.5px 171.5px;
    height: 171.5px;
    width: 3670.5px;
}
.parallax-bg-2 {
    position: absolute;
    left: calc(~'-3400px' - 50vw);
    bottom: 0px;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_bottom.png) bottom left
        no-repeat;
    background-size: 5954.5px 804px;
    height: 804px;
    width: 5954.5px;
}
.absBottom {
    overflow: visible;
    // border-top: 1px solid #efefef;
    text-align: center;
    position: absolute;
    z-index: 100000;
    bottom: 50px;
    width: 100%;
    margin: 0;
}
</style>
